import { BudgetCapping } from '../../../../__generated__/graphql'
import { CampaignCreateAdgroupDraft } from './campaignCreateDrafts'

export const sumAllocatedOpportunityBudget = (drafts: CampaignCreateAdgroupDraft[]): number =>
  drafts.reduce((sum, draft) => {
    if (draft.budgetCappingType === BudgetCapping.Open) return sum
    const capped = draft.budgetCapping ?? 0
    return sum + (Number.isFinite(capped) ? capped : 0)
  }, 0)

export const getOpportunityBudgetRemaining = (
  monetaryValue: number | null | undefined,
  drafts: CampaignCreateAdgroupDraft[]
): number => {
  if (monetaryValue == null || !Number.isFinite(monetaryValue)) return 0
  const total = Math.round(monetaryValue)
  const allocated = sumAllocatedOpportunityBudget(drafts)
  return Math.max(0, total - allocated)
}

export const getOpportunityBudgetPrefill = (remaining: number, maxBudgetCapping: number): number | null => {
  if (remaining <= 0) return null
  const max = Number(maxBudgetCapping)
  if (!Number.isFinite(max) || max <= 0) return remaining
  return Math.min(remaining, max)
}
